import { useEffect, useState } from 'react';
import Box from './Box';

function Loading() {

  return (
    <div style={{
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      position: 'fixed',
      display: 'flex',
      zIndex: '100'
    }}>
      <div style={{
        margin: 'auto'
      }}>
        <Box ><img src='/img/egg 360.gif' style={{ height: '100px' }} /> <br />
          <p style={{ fontSize: 30 }}>breeding takes 30 sec... </p>
        </Box>
      </div>
    </div>
  )
}

export default Loading;
